import * as Action from "@actions/index";

const InitialState = {
  status: "loading",
  list: [],
  error: "",
};

export default (state = InitialState, action: any) => {
  switch (action.type) {
    case Action.Main.Dynamic.SET_LIST:
      return { ...state, list: action.data };
    case Action.Main.Dynamic.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Main.Dynamic.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Main.Dynamic.CLEAR:
      return { ...state, data: {} };
    default:
      return state;
  }
};
